module.exports = __webpack_public_path__ + "img/gather ruffle.3f1a0fd3.png";